<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.278 13.5H3.722C3.04667 13.5 2.5 12.9527 2.5 12.278V3.722C2.5 3.04667 3.04733 2.5 3.722 2.5H12.2773C12.9527 2.5 13.4993 3.04733 13.4993 3.722V12.2773C13.5 12.9527 12.9527 13.5 12.278 13.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
